import { nanoid } from 'nanoid'
import { toastStore } from 'shared/ui'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { logger } from 'shared/lib'
import { RowConversion } from 'entities/Analytics/model/Table/rowConversion'
import type { EntitiesStore } from 'entities/EntitiesExport'

import { type Conversion, ConversionsApi } from 'entities/Conversion'
import { ConversionEditorStore } from 'widgets/ConversionEditor'
import { CopySnippetModal } from 'pages/analytics/pages/conversions/ui/CopySnippetModal/CopySnippetModal'

export const createConversion = (onSuccessCreate: () => void) => {
  new ConversionEditorStore({
    onSuccess: onSuccessCreate,
  })
}

export const editConversion = (
  conversion: RowConversion | Conversion,
  onSuccessEdit: () => void
) => {
  new ConversionEditorStore({
    onSuccess: onSuccessEdit,
    conversion: conversion instanceof RowConversion ? conversion.origin : conversion,
  })
}

export const deleteConversion = (
  conversion: RowConversion | Conversion,
  onSuccessDelete?: () => void
) => {
  const id = nanoid()
  modalStore.addModal({
    id,
    type: ModalTypeList.ALERT,
    title: ' Delete conversion?',
    desc: 'This action cannot be undone',
    primaryAction: {
      text: 'Delete',
      onAction: async () => {
        try {
          await ConversionsApi.deleteConversion(conversion.id)
          toastStore.add({
            type: 'success',
            title: 'Conversion deleted',
          })
          onSuccessDelete && onSuccessDelete()
        } catch (e) {
          logger.error(e)
        } finally {
          modalStore.closeModal(id)
        }
      },
    },
    secondaryAction: {
      text: 'Cancel',
      onAction: () => {
        modalStore.closeModal(id)
      },
    },
  })
}

export const copySnippet = (entities: EntitiesStore) => {
  const id = nanoid()

  modalStore.addModal({
    id: id,
    width: 480,
    type: ModalTypeList.DEFAULT,
    ModalContent: CopySnippetModal,
    ModalContentProps: { entities },
    title: 'Copy snippet',
    pureContent: true,
  })
}
